import { getGlobalHeadersAsObject } from "../global-headers";

export type AssignmentVoteCounts = {
	total: number;
	up: number;
};

/**
 * Bulk-fetch distinct-person vote counts for N assignments in a single
 * PG `GROUP BY assignment_id` query.
 *
 * Returns `{ [assignmentId]: { total, up } }`.
 */
export const getAssignmentVoteCountsBulk = async (
	assignmentIds: number[]
): Promise<Record<number, AssignmentVoteCounts>> => {
	if (assignmentIds.length === 0) return {};
	const ids = assignmentIds.join(",");
	const response = await fetch(`/api/v2/assignment_vote_counts_bulk/?ids=${ids}`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	});
	return response.json();
};
